export type Country = Readonly<{
  name: string;
  alpha2Code: string;
  alpha3Code: string;
  id: string;
  currencyCode: string;
  warehouse: string;
  continent: string;
  nsMapping: string;
  region: string;
}>;

export const DEFAULT_COUNTRY: Country = {
  name: 'United States of America',
  alpha2Code: 'US',
  alpha3Code: 'USA',
  id: '840',
  currencyCode: 'USD',
  warehouse: 'US',
  continent: 'NORTH AMERICA',
  nsMapping: '_unitedStates',
  region: 'default'
};

export const COUNTRIES: Country[] = [
  {
    name: 'Afghanistan',
    alpha2Code: 'AF',
    alpha3Code: 'AFG',
    id: '004',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'middle_east'
  },
  {
    name: 'Aland',
    alpha2Code: 'AX',
    alpha3Code: 'ALA',
    id: '248',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Albania',
    alpha2Code: 'AL',
    alpha3Code: 'ALB',
    id: '0',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_albania',
    region: 'europe'
  },
  {
    name: 'Algeria',
    alpha2Code: 'DZ',
    alpha3Code: 'DZA',
    id: '012',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_algeria',
    region: 'default'
  },
  {
    name: 'American Samoa',
    alpha2Code: 'AS',
    alpha3Code: 'ASM',
    id: '016',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Andorra',
    alpha2Code: 'AD',
    alpha3Code: 'AND',
    id: '020',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_andorra',
    region: 'europe'
  },
  {
    name: 'Angola',
    alpha2Code: 'AO',
    alpha3Code: 'AGO',
    id: '024',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_angola',
    region: 'default'
  },
  {
    name: 'Anguilla',
    alpha2Code: 'AI',
    alpha3Code: 'AIA',
    id: '660',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_anguilla',
    region: 'default'
  },
  {
    name: 'Antarctica',
    alpha2Code: 'AQ',
    alpha3Code: 'ATA',
    id: '010',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ANTARCTICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Antigua and Barbuda',
    alpha2Code: 'AG',
    alpha3Code: 'ATG',
    id: '2',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_antiguaAndBarbuda',
    region: 'default'
  },
  {
    name: 'Argentina',
    alpha2Code: 'AR',
    alpha3Code: 'ARG',
    id: '032',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'SOUTH AMERICA',
    nsMapping: '_argentina',
    region: 'default'
  },
  {
    name: 'Armenia',
    alpha2Code: 'AM',
    alpha3Code: 'ARM',
    id: '051',
    currencyCode: 'USD',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '',
    region: 'middle_east'
  },
  {
    name: 'Aruba',
    alpha2Code: 'AW',
    alpha3Code: 'ABW',
    id: '533',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_aruba',
    region: 'default'
  },
  {
    name: 'Australia',
    alpha2Code: 'AU',
    alpha3Code: 'AUS',
    id: '036',
    currencyCode: 'AUD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '_australia',
    region: 'australia'
  },
  {
    name: 'Austria',
    alpha2Code: 'AT',
    alpha3Code: 'AUT',
    id: '040',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_austria',
    region: 'europe'
  },
  {
    name: 'Azerbaijan',
    alpha2Code: 'AZ',
    alpha3Code: 'AZE',
    id: '031',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '_azerbaijan',
    region: 'middle_east'
  },
  {
    name: 'Bahamas',
    alpha2Code: 'BS',
    alpha3Code: 'BHS',
    id: '044',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_bahamas',
    region: 'default'
  },
  {
    name: 'Bahrain',
    alpha2Code: 'BH',
    alpha3Code: 'BHR',
    id: '4',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_bahrain',
    region: 'middle_east'
  },
  {
    name: 'Bangladesh',
    alpha2Code: 'BD',
    alpha3Code: 'BGD',
    id: '050',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_bangladesh',
    region: 'asia'
  },
  {
    name: 'Barbados',
    alpha2Code: 'BB',
    alpha3Code: 'BRB',
    id: '052',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_barbados',
    region: 'default'
  },
  {
    name: 'Belarus',
    alpha2Code: 'BY',
    alpha3Code: 'BLR',
    id: '112',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '_belarus',
    region: 'default'
  },
  {
    name: 'Belgium',
    alpha2Code: 'BE',
    alpha3Code: 'BEL',
    id: '056',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_belgium',
    region: 'europe'
  },
  {
    name: 'Belize',
    alpha2Code: 'BZ',
    alpha3Code: 'BLZ',
    id: '04',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_belize',
    region: 'default'
  },
  {
    name: 'Benin',
    alpha2Code: 'BJ',
    alpha3Code: 'BEN',
    id: '204',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Bermuda',
    alpha2Code: 'BM',
    alpha3Code: 'BMU',
    id: '060',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_bermuda',
    region: 'default'
  },
  {
    name: 'Bhutan',
    alpha2Code: 'BT',
    alpha3Code: 'BTN',
    id: '064',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_bhutan',
    region: 'asia'
  },
  {
    name: 'Bolivia',
    alpha2Code: 'BO',
    alpha3Code: 'BOL',
    id: '6',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'SOUTH AMERICA',
    nsMapping: '_bolivia',
    region: 'default'
  },
  {
    name: 'Bosnia and Herzegovina',
    alpha2Code: 'BA',
    alpha3Code: 'BIH',
    id: '070',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_bosniaAndHerzegovina',
    region: 'europe'
  },
  {
    name: 'Botswana',
    alpha2Code: 'BW',
    alpha3Code: 'BWA',
    id: '072',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_botswana',
    region: 'default'
  },
  {
    name: 'Bouvet Island',
    alpha2Code: 'BV',
    alpha3Code: 'BVT',
    id: '074',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ANTARCTICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Brazil',
    alpha2Code: 'BR',
    alpha3Code: 'BRA',
    id: '076',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'SOUTH AMERICA',
    nsMapping: '_brazil',
    region: 'default'
  },
  {
    name: 'British Indian Ocean Territory',
    alpha2Code: 'IO',
    alpha3Code: 'IOT',
    id: '06',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Brunei Darussalam',
    alpha2Code: 'BN',
    alpha3Code: 'BRN',
    id: '006',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_bruneiDarussalam',
    region: 'asia'
  },
  {
    name: 'Bulgaria',
    alpha2Code: 'BG',
    alpha3Code: 'BGR',
    id: '100',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_bulgaria',
    region: 'europe'
  },
  {
    name: 'Burkina Faso',
    alpha2Code: 'BF',
    alpha3Code: 'BFA',
    id: '854',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Burundi',
    alpha2Code: 'BI',
    alpha3Code: 'BDI',
    id: '108',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Cambodia',
    alpha2Code: 'KH',
    alpha3Code: 'KHM',
    id: '116',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_cambodia',
    region: 'asia'
  },
  {
    name: 'Cameroon',
    alpha2Code: 'CM',
    alpha3Code: 'CMR',
    id: '120',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Canada',
    alpha2Code: 'CA',
    alpha3Code: 'CAN',
    id: '124',
    currencyCode: 'CAD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_canada',
    region: 'canada'
  },
  {
    name: 'Cape Verde',
    alpha2Code: 'CV',
    alpha3Code: 'CPV',
    id: '132',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_capeVerde',
    region: 'default'
  },
  {
    name: 'Cayman Islands',
    alpha2Code: 'KY',
    alpha3Code: 'CYM',
    id: '136',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_caymanIslands',
    region: 'default'
  },
  {
    name: 'Central African Republic',
    alpha2Code: 'CF',
    alpha3Code: 'CAF',
    id: '140',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Chad',
    alpha2Code: 'TD',
    alpha3Code: 'TCD',
    id: '148',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Chile',
    alpha2Code: 'CL',
    alpha3Code: 'CHL',
    id: '152',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'SOUTH AMERICA',
    nsMapping: '_chile',
    region: 'default'
  },
  {
    name: 'China',
    alpha2Code: 'CN',
    alpha3Code: 'CHN',
    id: '156',
    currencyCode: 'CNY',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_china',
    region: 'china'
  },
  {
    name: 'Christmas Island',
    alpha2Code: 'CX',
    alpha3Code: 'CXR',
    id: '162',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Cocos (Keeling) Islands',
    alpha2Code: 'CC',
    alpha3Code: 'CCK',
    id: '166',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Colombia',
    alpha2Code: 'CO',
    alpha3Code: 'COL',
    id: '170',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'SOUTH AMERICA',
    nsMapping: '_colombia',
    region: 'default'
  },
  {
    name: 'Comoros',
    alpha2Code: 'KM',
    alpha3Code: 'COM',
    id: '174',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_comoros',
    region: 'default'
  },
  {
    name: 'Cook Islands',
    alpha2Code: 'CK',
    alpha3Code: 'COK',
    id: '184',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '_cookIslands',
    region: 'default'
  },
  {
    name: 'Costa Rica',
    alpha2Code: 'CR',
    alpha3Code: 'CRI',
    id: '188',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_costaRica',
    region: 'default'
  },
  {
    name: "Cote d'Ivoire",
    alpha2Code: 'CI',
    alpha3Code: 'CIV',
    id: '384',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Croatia',
    alpha2Code: 'HR',
    alpha3Code: 'HRV',
    id: '191',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_croatiaHrvatska',
    region: 'europe'
  },
  {
    name: 'Cuba',
    alpha2Code: 'CU',
    alpha3Code: 'CUB',
    id: '192',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Cyprus',
    alpha2Code: 'CY',
    alpha3Code: 'CYP',
    id: '196',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_cyprus',
    region: 'europe'
  },
  {
    name: 'Czech Republic',
    alpha2Code: 'CZ',
    alpha3Code: 'CZE',
    id: '203',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_czechRepublic',
    region: 'europe'
  },
  {
    name: 'Denmark',
    alpha2Code: 'DK',
    alpha3Code: 'DNK',
    id: '208',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_denmark',
    region: 'europe'
  },
  {
    name: 'Djibouti',
    alpha2Code: 'DJ',
    alpha3Code: 'DJI',
    id: '262',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Dominica',
    alpha2Code: 'DM',
    alpha3Code: 'DMA',
    id: '212',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_dominica',
    region: 'default'
  },
  {
    name: 'Dominican Republic',
    alpha2Code: 'DO',
    alpha3Code: 'DOM',
    id: '214',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_dominicanRepublic',
    region: 'default'
  },
  {
    name: 'Ecuador',
    alpha2Code: 'EC',
    alpha3Code: 'ECU',
    id: '218',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'SOUTH AMERICA',
    nsMapping: '_ecuador',
    region: 'default'
  },
  {
    name: 'Egypt',
    alpha2Code: 'EG',
    alpha3Code: 'EGY',
    id: '818',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_egypt',
    region: 'middle_east'
  },
  {
    name: 'El Salvador',
    alpha2Code: 'SV',
    alpha3Code: 'SLV',
    id: '222',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_elSalvador',
    region: 'default'
  },
  {
    name: 'Equatorial Guinea',
    alpha2Code: 'GQ',
    alpha3Code: 'GNQ',
    id: '226',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Eritrea',
    alpha2Code: 'ER',
    alpha3Code: 'ERI',
    id: '232',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Estonia',
    alpha2Code: 'EE',
    alpha3Code: 'EST',
    id: '233',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_estonia',
    region: 'europe'
  },
  {
    name: 'Ethiopia',
    alpha2Code: 'ET',
    alpha3Code: 'ETH',
    id: '231',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Falkland Islands',
    alpha2Code: 'FK',
    alpha3Code: 'FLK',
    id: '238',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'SOUTH AMERICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Faroe Islands',
    alpha2Code: 'FO',
    alpha3Code: 'FRO',
    id: '234',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '_faroeIslands',
    region: 'default'
  },
  {
    name: 'Fiji',
    alpha2Code: 'FJ',
    alpha3Code: 'FJI',
    id: '242',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '_fiji',
    region: 'default'
  },
  {
    name: 'Finland',
    alpha2Code: 'FI',
    alpha3Code: 'FIN',
    id: '246',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_finland',
    region: 'europe'
  },
  {
    name: 'France',
    alpha2Code: 'FR',
    alpha3Code: 'FRA',
    id: '250',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_france',
    region: 'europe'
  },
  {
    name: 'French Guiana',
    alpha2Code: 'GF',
    alpha3Code: 'GUF',
    id: '254',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'SOUTH AMERICA',
    nsMapping: '_frenchGuiana',
    region: 'default'
  },
  {
    name: 'French Polynesia',
    alpha2Code: 'PF',
    alpha3Code: 'PYF',
    id: '258',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '_frenchPolynesia',
    region: 'default'
  },
  {
    name: 'French Southern Lands',
    alpha2Code: 'TF',
    alpha3Code: 'ATF',
    id: '260',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ANTARCTICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Gabon',
    alpha2Code: 'GA',
    alpha3Code: 'GAB',
    id: '266',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_gabon',
    region: 'default'
  },
  {
    name: 'Gambia',
    alpha2Code: 'GM',
    alpha3Code: 'GMB',
    id: '270',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_gambia',
    region: 'default'
  },
  {
    name: 'Georgia',
    alpha2Code: 'GE',
    alpha3Code: 'GEO',
    id: '268',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '_georgia',
    region: 'middle_east'
  },
  {
    name: 'Germany',
    alpha2Code: 'DE',
    alpha3Code: 'DEU',
    id: '276',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_germany',
    region: 'europe'
  },
  {
    name: 'Ghana',
    alpha2Code: 'GH',
    alpha3Code: 'GHA',
    id: '288',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_ghana',
    region: 'default'
  },
  {
    name: 'Gibraltar',
    alpha2Code: 'GI',
    alpha3Code: 'GIB',
    id: '292',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '_gibraltar',
    region: 'default'
  },
  {
    name: 'Greece',
    alpha2Code: 'GR',
    alpha3Code: 'GRC',
    id: '300',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_greece',
    region: 'europe'
  },
  {
    name: 'Greenland',
    alpha2Code: 'GL',
    alpha3Code: 'GRL',
    id: '304',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_greenland',
    region: 'default'
  },
  {
    name: 'Grenada',
    alpha2Code: 'GD',
    alpha3Code: 'GRD',
    id: '308',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_grenada',
    region: 'default'
  },
  {
    name: 'Guadeloupe',
    alpha2Code: 'GP',
    alpha3Code: 'GLP',
    id: '312',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_guadeloupe',
    region: 'default'
  },
  {
    name: 'Guam',
    alpha2Code: 'GU',
    alpha3Code: 'GUM',
    id: '316',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '_guam',
    region: 'default'
  },
  {
    name: 'Guatemala',
    alpha2Code: 'GT',
    alpha3Code: 'GTM',
    id: '320',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_guatemala',
    region: 'default'
  },
  {
    name: 'Guernsey',
    alpha2Code: 'GG',
    alpha3Code: 'GGY',
    id: '831',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '_guernsey',
    region: 'default'
  },
  {
    name: 'Guinea',
    alpha2Code: 'GN',
    alpha3Code: 'GIN',
    id: '324',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Guinea-Bissau',
    alpha2Code: 'GW',
    alpha3Code: 'GNB',
    id: '624',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Guyana',
    alpha2Code: 'GY',
    alpha3Code: 'GUY',
    id: '328',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'SOUTH AMERICA',
    nsMapping: '_guyana',
    region: 'default'
  },
  {
    name: 'Haiti',
    alpha2Code: 'HT',
    alpha3Code: 'HTI',
    id: '332',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Heard and McDonald Islands',
    alpha2Code: 'HM',
    alpha3Code: 'HMD',
    id: '334',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ANTARCTICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Honduras',
    alpha2Code: 'HN',
    alpha3Code: 'HND',
    id: '340',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_honduras',
    region: 'default'
  },
  {
    name: 'Hong Kong SAR',
    alpha2Code: 'HK',
    alpha3Code: 'HKG',
    id: '344',
    currencyCode: 'HKD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_hongKong',
    region: 'hong_kong'
  },
  {
    name: 'Hungary',
    alpha2Code: 'HU',
    alpha3Code: 'HUN',
    id: '348',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_hungary',
    region: 'europe'
  },
  {
    name: 'Iceland',
    alpha2Code: 'IS',
    alpha3Code: 'ISL',
    id: '352',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_iceland',
    region: 'europe'
  },
  {
    name: 'India',
    alpha2Code: 'IN',
    alpha3Code: 'IND',
    id: '356',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_india',
    region: 'asia'
  },
  {
    name: 'Indonesia',
    alpha2Code: 'ID',
    alpha3Code: 'IDN',
    id: '360',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_indonesia',
    region: 'asia'
  },
  {
    name: 'Iran',
    alpha2Code: 'IR',
    alpha3Code: 'IRN',
    id: '364',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'middle_east'
  },
  {
    name: 'Iraq',
    alpha2Code: 'IQ',
    alpha3Code: 'IRQ',
    id: '368',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'middle_east'
  },
  {
    name: 'Ireland',
    alpha2Code: 'IE',
    alpha3Code: 'IRL',
    id: '372',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_ireland',
    region: 'europe'
  },
  {
    name: 'Isle of Man',
    alpha2Code: 'IM',
    alpha3Code: 'IMN',
    id: '833',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Israel',
    alpha2Code: 'IL',
    alpha3Code: 'ISR',
    id: '376',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_israel',
    region: 'middle_east'
  },
  {
    name: 'Italy',
    alpha2Code: 'IT',
    alpha3Code: 'ITA',
    id: '380',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_italy',
    region: 'europe'
  },
  {
    name: 'Jamaica',
    alpha2Code: 'JM',
    alpha3Code: 'JAM',
    id: '388',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_jamaica',
    region: 'default'
  },
  {
    name: 'Japan',
    alpha2Code: 'JP',
    alpha3Code: 'JPN',
    id: '392',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_japan',
    region: 'asia'
  },
  {
    name: 'Jersey',
    alpha2Code: 'JE',
    alpha3Code: 'JEY',
    id: '832',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '_jersey',
    region: 'default'
  },
  {
    name: 'Jordan',
    alpha2Code: 'JO',
    alpha3Code: 'JOR',
    id: '400',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_jordan',
    region: 'middle_east'
  },
  {
    name: 'Kazakhstan',
    alpha2Code: 'KZ',
    alpha3Code: 'KAZ',
    id: '398',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_kazakhstan',
    region: 'asia'
  },
  {
    name: 'Kenya',
    alpha2Code: 'KE',
    alpha3Code: 'KEN',
    id: '404',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_kenya',
    region: 'default'
  },
  {
    name: 'Kiribati',
    alpha2Code: 'KI',
    alpha3Code: 'KIR',
    id: '296',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'North Korea',
    alpha2Code: 'KP',
    alpha3Code: 'PRK',
    id: '408',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'asia'
  },
  {
    name: 'Kuwait',
    alpha2Code: 'KW',
    alpha3Code: 'KWT',
    id: '414',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_kuwait',
    region: 'middle_east'
  },
  {
    name: 'Kyrgyzstan',
    alpha2Code: 'KG',
    alpha3Code: 'KGZ',
    id: '417',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'asia'
  },
  {
    name: 'Laos',
    alpha2Code: 'LA',
    alpha3Code: 'LAO',
    id: '418',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_laoPeoplesDemocraticRepublic',
    region: 'asia'
  },
  {
    name: 'Latvia',
    alpha2Code: 'LV',
    alpha3Code: 'LVA',
    id: '428',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_latvia',
    region: 'europe'
  },
  {
    name: 'Lebanon',
    alpha2Code: 'LB',
    alpha3Code: 'LBN',
    id: '422',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'middle_east'
  },
  {
    name: 'Lesotho',
    alpha2Code: 'LS',
    alpha3Code: 'LSO',
    id: '426',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_lesotho',
    region: 'default'
  },
  {
    name: 'Liberia',
    alpha2Code: 'LR',
    alpha3Code: 'LBR',
    id: '430',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Libya',
    alpha2Code: 'LY',
    alpha3Code: 'LBY',
    id: '434',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Liechtenstein',
    alpha2Code: 'LI',
    alpha3Code: 'LIE',
    id: '438',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_liechtenstein',
    region: 'europe'
  },
  {
    name: 'Lithuania',
    alpha2Code: 'LT',
    alpha3Code: 'LTU',
    id: '440',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_lithuania',
    region: 'europe'
  },
  {
    name: 'Luxembourg',
    alpha2Code: 'LU',
    alpha3Code: 'LUX',
    id: '442',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_luxembourg',
    region: 'europe'
  },
  {
    name: 'Macau SAR',
    alpha2Code: 'MO',
    alpha3Code: 'MAC',
    id: '446',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_macau',
    region: 'asia'
  },
  {
    name: 'Macedonia',
    alpha2Code: 'MK',
    alpha3Code: 'MKD',
    id: '807',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_macedonia',
    region: 'europe'
  },
  {
    name: 'Madagascar',
    alpha2Code: 'MG',
    alpha3Code: 'MDG',
    id: '450',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_madagascar',
    region: 'default'
  },
  {
    name: 'Malawi',
    alpha2Code: 'MW',
    alpha3Code: 'MWI',
    id: '454',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_malawi',
    region: 'default'
  },
  {
    name: 'Malaysia',
    alpha2Code: 'MY',
    alpha3Code: 'MYS',
    id: '458',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_malaysia',
    region: 'asia'
  },
  {
    name: 'Maldives',
    alpha2Code: 'MV',
    alpha3Code: 'MDV',
    id: '462',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_maldives',
    region: 'asia'
  },
  {
    name: 'Mali',
    alpha2Code: 'ML',
    alpha3Code: 'MLI',
    id: '466',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Malta',
    alpha2Code: 'MT',
    alpha3Code: 'MLT',
    id: '470',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_malta',
    region: 'europe'
  },
  {
    name: 'Marshall Islands',
    alpha2Code: 'MH',
    alpha3Code: 'MHL',
    id: '584',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Martinique',
    alpha2Code: 'MQ',
    alpha3Code: 'MTQ',
    id: '474',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_martinique',
    region: 'default'
  },
  {
    name: 'Mauritania',
    alpha2Code: 'MR',
    alpha3Code: 'MRT',
    id: '478',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Mauritius',
    alpha2Code: 'MU',
    alpha3Code: 'MUS',
    id: '480',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Mayotte',
    alpha2Code: 'YT',
    alpha3Code: 'MYT',
    id: '175',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_mayotte',
    region: 'default'
  },
  {
    name: 'Mexico',
    alpha2Code: 'MX',
    alpha3Code: 'MEX',
    id: '484',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_mexico',
    region: 'default'
  },
  {
    name: 'Micronesia',
    alpha2Code: 'FM',
    alpha3Code: 'FSM',
    id: '583',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Moldova',
    alpha2Code: 'MD',
    alpha3Code: 'MDA',
    id: '498',
    currencyCode: 'EUR',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '_moldovaRepublicOf',
    region: 'europe'
  },
  {
    name: 'Monaco',
    alpha2Code: 'MC',
    alpha3Code: 'MCO',
    id: '492',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_monaco',
    region: 'europe'
  },
  {
    name: 'Mongolia',
    alpha2Code: 'MN',
    alpha3Code: 'MNG',
    id: '496',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_mongolia',
    region: 'asia'
  },
  {
    name: 'Montenegro',
    alpha2Code: 'ME',
    alpha3Code: 'MNE',
    id: '499',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_montenegro',
    region: 'europe'
  },
  {
    name: 'Montserrat',
    alpha2Code: 'MS',
    alpha3Code: 'MSR',
    id: '500',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_montserrat',
    region: 'default'
  },
  {
    name: 'Morocco',
    alpha2Code: 'MA',
    alpha3Code: 'MAR',
    id: '504',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_morocco',
    region: 'default'
  },
  {
    name: 'Mozambique',
    alpha2Code: 'MZ',
    alpha3Code: 'MOZ',
    id: '508',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_mozambique',
    region: 'default'
  },
  {
    name: 'Myanmar',
    alpha2Code: 'MM',
    alpha3Code: 'MMR',
    id: '104',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'asia'
  },
  {
    name: 'Namibia',
    alpha2Code: 'NA',
    alpha3Code: 'NAM',
    id: '516',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_namibia',
    region: 'default'
  },
  {
    name: 'Nauru',
    alpha2Code: 'NR',
    alpha3Code: 'NRU',
    id: '520',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Nepal',
    alpha2Code: 'NP',
    alpha3Code: 'NPL',
    id: '524',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_nepal',
    region: 'asia'
  },
  {
    name: 'Netherlands',
    alpha2Code: 'NL',
    alpha3Code: 'NLD',
    id: '528',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_netherlands',
    region: 'europe'
  },
  {
    name: 'Netherlands Antilles',
    alpha2Code: 'AN',
    alpha3Code: 'ANT',
    id: '530',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'New Caledonia',
    alpha2Code: 'NC',
    alpha3Code: 'NCL',
    id: '540',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '_newCaledonia',
    region: 'default'
  },
  {
    name: 'New Zealand',
    alpha2Code: 'NZ',
    alpha3Code: 'NZL',
    id: '554',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '_newZealand',
    region: 'default'
  },
  {
    name: 'Nicaragua',
    alpha2Code: 'NI',
    alpha3Code: 'NIC',
    id: '558',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_nicaragua',
    region: 'default'
  },
  {
    name: 'Niger',
    alpha2Code: 'NE',
    alpha3Code: 'NER',
    id: '562',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Nigeria',
    alpha2Code: 'NG',
    alpha3Code: 'NGA',
    id: '566',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Niue',
    alpha2Code: 'NU',
    alpha3Code: 'NIU',
    id: '570',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Norfolk Island',
    alpha2Code: 'NF',
    alpha3Code: 'NFK',
    id: '574',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Northern Mariana Islands',
    alpha2Code: 'MP',
    alpha3Code: 'MNP',
    id: '580',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Norway',
    alpha2Code: 'NO',
    alpha3Code: 'NOR',
    id: '578',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_norway',
    region: 'europe'
  },
  {
    name: 'Oman',
    alpha2Code: 'OM',
    alpha3Code: 'OMN',
    id: '512',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_oman',
    region: 'middle_east'
  },
  {
    name: 'Pakistan',
    alpha2Code: 'PK',
    alpha3Code: 'PAK',
    id: '586',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'middle_east'
  },
  {
    name: 'Palau',
    alpha2Code: 'PW',
    alpha3Code: 'PLW',
    id: '585',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Palestine',
    alpha2Code: 'PS',
    alpha3Code: 'PSE',
    id: '275',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'middle_east'
  },
  {
    name: 'Panama',
    alpha2Code: 'PA',
    alpha3Code: 'PAN',
    id: '591',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_panama',
    region: 'default'
  },
  {
    name: 'Papua New Guinea',
    alpha2Code: 'PG',
    alpha3Code: 'PNG',
    id: '598',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '_papuaNewGuinea',
    region: 'default'
  },
  {
    name: 'Paraguay',
    alpha2Code: 'PY',
    alpha3Code: 'PRY',
    id: '600',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'SOUTH AMERICA',
    nsMapping: '_paraguay',
    region: 'default'
  },
  {
    name: 'Peru',
    alpha2Code: 'PE',
    alpha3Code: 'PER',
    id: '604',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'SOUTH AMERICA',
    nsMapping: '_peru',
    region: 'default'
  },
  {
    name: 'Philippines',
    alpha2Code: 'PH',
    alpha3Code: 'PHL',
    id: '608',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_philippines',
    region: 'asia'
  },
  {
    name: 'Pitcairn',
    alpha2Code: 'PN',
    alpha3Code: 'PCN',
    id: '612',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Poland',
    alpha2Code: 'PL',
    alpha3Code: 'POL',
    id: '616',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_poland',
    region: 'europe'
  },
  {
    name: 'Portugal',
    alpha2Code: 'PT',
    alpha3Code: 'PRT',
    id: '620',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_portugal',
    region: 'europe'
  },
  {
    name: 'Puerto Rico',
    alpha2Code: 'PR',
    alpha3Code: 'PRI',
    id: '630',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_puertoRico',
    region: 'default'
  },
  {
    name: 'Qatar',
    alpha2Code: 'QA',
    alpha3Code: 'QAT',
    id: '634',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_qatar',
    region: 'middle_east'
  },
  {
    name: 'Reunion',
    alpha2Code: 'RE',
    alpha3Code: 'REU',
    id: '638',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Romania',
    alpha2Code: 'RO',
    alpha3Code: 'ROU',
    id: '642',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_romania',
    region: 'europe'
  },
  {
    name: 'Rwanda',
    alpha2Code: 'RW',
    alpha3Code: 'RWA',
    id: '646',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Saint Barthelemy',
    alpha2Code: 'BL',
    alpha3Code: 'BLM',
    id: '652',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Saint Helena',
    alpha2Code: 'SH',
    alpha3Code: 'SHN',
    id: '654',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Saint Kitts and Nevis',
    alpha2Code: 'KN',
    alpha3Code: 'KNA',
    id: '659',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_saintKittsAndNevis',
    region: 'default'
  },
  {
    name: 'Saint Lucia',
    alpha2Code: 'LC',
    alpha3Code: 'LCA',
    id: '662',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_saintLucia',
    region: 'default'
  },
  {
    name: 'Saint Martin (French part)',
    alpha2Code: 'MF',
    alpha3Code: 'MAF',
    id: '663',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Saint Pierre and Miquelon',
    alpha2Code: 'PM',
    alpha3Code: 'SPM',
    id: '666',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Saint Vincent and the Grenadines',
    alpha2Code: 'VC',
    alpha3Code: 'VCT',
    id: '670',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_saintVincentAndTheGrenadines',
    region: 'default'
  },
  {
    name: 'Samoa',
    alpha2Code: 'WS',
    alpha3Code: 'WSM',
    id: '882',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '_samoa',
    region: 'default'
  },
  {
    name: 'San Marino',
    alpha2Code: 'SM',
    alpha3Code: 'SMR',
    id: '674',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_sanMarino',
    region: 'europe'
  },
  {
    name: 'Sao Tome and Principe',
    alpha2Code: 'ST',
    alpha3Code: 'STP',
    id: '678',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Saudi Arabia',
    alpha2Code: 'SA',
    alpha3Code: 'SAU',
    id: '682',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_saudiArabia',
    region: 'middle_east'
  },
  {
    name: 'Senegal',
    alpha2Code: 'SN',
    alpha3Code: 'SEN',
    id: '686',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_senegal',
    region: 'default'
  },
  {
    name: 'Serbia',
    alpha2Code: 'RS',
    alpha3Code: 'SRB',
    id: '688',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '_serbia',
    region: 'default'
  },
  {
    name: 'Seychelles',
    alpha2Code: 'SC',
    alpha3Code: 'SYC',
    id: '690',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_seychelles',
    region: 'default'
  },
  {
    name: 'Sierra Leone',
    alpha2Code: 'SL',
    alpha3Code: 'SLE',
    id: '694',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Singapore',
    alpha2Code: 'SG',
    alpha3Code: 'SGP',
    id: '702',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_singapore',
    region: 'asia'
  },
  {
    name: 'Slovakia',
    alpha2Code: 'SK',
    alpha3Code: 'SVK',
    id: '703',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_slovakRepublic',
    region: 'europe'
  },
  {
    name: 'Slovenia',
    alpha2Code: 'SI',
    alpha3Code: 'SVN',
    id: '705',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_slovenia',
    region: 'europe'
  },
  {
    name: 'Solomon Islands',
    alpha2Code: 'SB',
    alpha3Code: 'SLB',
    id: '00',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '_solomonIslands',
    region: 'default'
  },
  {
    name: 'Somalia',
    alpha2Code: 'SO',
    alpha3Code: 'SOM',
    id: '706',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'South Africa',
    alpha2Code: 'ZA',
    alpha3Code: 'ZAF',
    id: '710',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_southAfrica',
    region: 'default'
  },
  {
    name: 'South Georgia and South Sandwich Islands',
    alpha2Code: 'GS',
    alpha3Code: 'SGS',
    id: '239',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ANTARCTICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'South Korea',
    alpha2Code: 'KR',
    alpha3Code: 'KOR',
    id: '410',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_koreaDemocraticPeoplesRepublic',
    region: 'asia'
  },
  {
    name: 'Spain',
    alpha2Code: 'ES',
    alpha3Code: 'ESP',
    id: '724',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_spain',
    region: 'europe'
  },
  {
    name: 'Sri Lanka',
    alpha2Code: 'LK',
    alpha3Code: 'LKA',
    id: '144',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_sriLanka',
    region: 'asia'
  },
  {
    name: 'Sudan',
    alpha2Code: 'SD',
    alpha3Code: 'SDN',
    id: '736',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Suriname',
    alpha2Code: 'SR',
    alpha3Code: 'SUR',
    id: '740',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'SOUTH AMERICA',
    nsMapping: '_suriname',
    region: 'default'
  },
  {
    name: 'Svalbard and Jan Mayen Islands',
    alpha2Code: 'SJ',
    alpha3Code: 'SJM',
    id: '744',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Swaziland',
    alpha2Code: 'SZ',
    alpha3Code: 'SWZ',
    id: '748',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'AFRICA',
    nsMapping: '_swaziland',
    region: 'europe'
  },
  {
    name: 'Sweden',
    alpha2Code: 'SE',
    alpha3Code: 'SWE',
    id: '752',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_sweden',
    region: 'europe'
  },
  {
    name: 'Switzerland',
    alpha2Code: 'CH',
    alpha3Code: 'CHE',
    id: '756',
    currencyCode: 'EUR',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_switzerland',
    region: 'europe'
  },
  {
    name: 'Syria',
    alpha2Code: 'SY',
    alpha3Code: 'SYR',
    id: '760',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'middle_east'
  },
  {
    name: 'Taiwan Region',
    alpha2Code: 'TW',
    alpha3Code: 'TWN',
    id: '158',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_taiwan',
    region: 'asia'
  },
  {
    name: 'Tajikistan',
    alpha2Code: 'TJ',
    alpha3Code: 'TJK',
    id: '762',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'asia'
  },
  {
    name: 'Tanzania',
    alpha2Code: 'TZ',
    alpha3Code: 'TZA',
    id: '834',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_tanzania',
    region: 'default'
  },
  {
    name: 'Thailand',
    alpha2Code: 'TH',
    alpha3Code: 'THA',
    id: '764',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_thailand',
    region: 'asia'
  },
  {
    name: 'Timor-Leste',
    alpha2Code: 'TL',
    alpha3Code: 'TLS',
    id: '626',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_eastTimor',
    region: 'default'
  },
  {
    name: 'Togo',
    alpha2Code: 'TG',
    alpha3Code: 'TGO',
    id: '768',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_togo',
    region: 'default'
  },
  {
    name: 'Tokelau',
    alpha2Code: 'TK',
    alpha3Code: 'TKL',
    id: '772',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Tonga',
    alpha2Code: 'TO',
    alpha3Code: 'TON',
    id: '776',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '_tonga',
    region: 'default'
  },
  {
    name: 'Trinidad and Tobago',
    alpha2Code: 'TT',
    alpha3Code: 'TTO',
    id: '780',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_trinidadAndTobago',
    region: 'default'
  },
  {
    name: 'Tunisia',
    alpha2Code: 'TN',
    alpha3Code: 'TUN',
    id: '788',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '_tunisia',
    region: 'default'
  },
  {
    name: 'Turkey',
    alpha2Code: 'TR',
    alpha3Code: 'TUR',
    id: '792',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_turkey',
    region: 'middle_east'
  },
  {
    name: 'Turkmenistan',
    alpha2Code: 'TM',
    alpha3Code: 'TKM',
    id: '795',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'asia'
  },
  {
    name: 'Turks and Caicos Islands',
    alpha2Code: 'TC',
    alpha3Code: 'TCA',
    id: '796',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_turksAndCaicosIslands',
    region: 'default'
  },
  {
    name: 'Tuvalu',
    alpha2Code: 'TV',
    alpha3Code: 'TUV',
    id: '798',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '_tuvalu',
    region: 'default'
  },
  {
    name: 'Uganda',
    alpha2Code: 'UG',
    alpha3Code: 'UGA',
    id: '800',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Ukraine',
    alpha2Code: 'UA',
    alpha3Code: 'UKR',
    id: '804',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '_ukraine',
    region: 'default'
  },
  {
    name: 'United Arab Emirates',
    alpha2Code: 'AE',
    alpha3Code: 'ARE',
    id: '784',
    currencyCode: 'AED',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_unitedArabEmirates',
    region: 'united_arab_emirates'
  },
  {
    name: 'United Kingdom',
    alpha2Code: 'GB',
    alpha3Code: 'GBR',
    id: '826',
    currencyCode: 'GBP',
    warehouse: 'UK',
    continent: 'EUROPE',
    nsMapping: '_unitedKingdom',
    region: 'united_kingdom'
  },
  {
    name: 'United States Minor Outlying Islands',
    alpha2Code: 'UM',
    alpha3Code: 'UMI',
    id: '581',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '',
    region: 'default'
  },
  DEFAULT_COUNTRY,
  {
    name: 'Uruguay',
    alpha2Code: 'UY',
    alpha3Code: 'URY',
    id: '858',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'SOUTH AMERICA',
    nsMapping: '_uruguay',
    region: 'default'
  },
  {
    name: 'Uzbekistan',
    alpha2Code: 'UZ',
    alpha3Code: 'UZB',
    id: '860',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'asia'
  },
  {
    name: 'Vanuatu',
    alpha2Code: 'VU',
    alpha3Code: 'VUT',
    id: '548',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '_vanuatu',
    region: 'default'
  },
  {
    name: 'Vatican City',
    alpha2Code: 'VA',
    alpha3Code: 'VAT',
    id: '336',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'EUROPE',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Venezuela',
    alpha2Code: 'VE',
    alpha3Code: 'VEN',
    id: '862',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'SOUTH AMERICA',
    nsMapping: '_venezuela',
    region: 'default'
  },
  {
    name: 'Vietnam',
    alpha2Code: 'VN',
    alpha3Code: 'VNM',
    id: '704',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '_vietnam',
    region: 'asia'
  },
  {
    name: 'Virgin Islands, British',
    alpha2Code: 'VG',
    alpha3Code: 'VGB',
    id: '02',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_virginIslandsBritish',
    region: 'default'
  },
  {
    name: 'Virgin Islands, U.S.',
    alpha2Code: 'VI',
    alpha3Code: 'VIR',
    id: '850',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'NORTH AMERICA',
    nsMapping: '_virginIslandsUSA',
    region: 'default'
  },
  {
    name: 'Wallis and Futuna Islands',
    alpha2Code: 'WF',
    alpha3Code: 'WLF',
    id: '876',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'OCEANIA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Western Sahara',
    alpha2Code: 'EH',
    alpha3Code: 'ESH',
    id: '732',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Yemen',
    alpha2Code: 'YE',
    alpha3Code: 'YEM',
    id: '887',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'ASIA',
    nsMapping: '',
    region: 'middle_east'
  },
  {
    name: 'Zambia',
    alpha2Code: 'ZM',
    alpha3Code: 'ZMB',
    id: '894',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  },
  {
    name: 'Zimbabwe',
    alpha2Code: 'ZW',
    alpha3Code: 'ZWE',
    id: '716',
    currencyCode: 'USD',
    warehouse: 'US',
    continent: 'AFRICA',
    nsMapping: '',
    region: 'default'
  }
];
